import type { FamilySize } from "../lib/premiums";

interface FamilyToggleProps {
  value: FamilySize;
  onChange: (size: FamilySize) => void;
}

const OPTIONS: { size: FamilySize; label: string; sub: string }[] = [
  { size: 1, label: "1", sub: "Individual" },
  { size: 2, label: "2+", sub: "Family" },
];

/** Two-position toggle selecting the Individual vs Family premium column. */
export function FamilyToggle({ value, onChange }: FamilyToggleProps) {
  return (
    <div className="field">
      <span className="field__label" id="family-label">
        Who is covered?
      </span>
      <div
        className="segmented"
        role="radiogroup"
        aria-labelledby="family-label"
      >
        {OPTIONS.map((opt) => (
          <button
            key={opt.size}
            type="button"
            role="radio"
            aria-checked={value === opt.size}
            className={`segmented__option${
              value === opt.size ? " segmented__option--active" : ""
            }`}
            onClick={() => onChange(opt.size)}
          >
            <span className="segmented__value">{opt.label}</span>
            <span className="segmented__sub">{opt.sub}</span>
          </button>
        ))}
      </div>
    </div>
  );
}
